const getRequest = async (config, body,  setItem, setError, setLoading) => {
        setLoading && setLoading(true);
        try {
            let headers = {}

            const textBody = body ? JSON.stringify(body) : null

            if (body) {
                headers['Content-Type'] ='application/json'
            }

            const url = config.url;
            const init = {method: (config.method || 'GET'), body: textBody, headers}

            const response = await fetch(url, init)
            const data    = await response.json()
            if (setItem) {
                setItem(data)
            }
            if (!response.ok) {
               // throw new Error(data.message || 'Что-то пошло не так')
            }

            setLoading && setLoading(false);

            return data
        } catch (e) {
            setLoading && setLoading(true);
            setError && setError(e.message)
            throw e
        }
    };

export default getRequest